module.exports = __webpack_public_path__ + "static/media/Paul_Ryan.af67488e.jpeg";